import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const NewMembershipErrorModal = (props) => {
  return (
    <Dialog
      open
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {props.title || 'Account creation failed'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.body || 'We apologize for the inconvenience. Please call us at 1-844-768-6945 to complete your sign-up.'}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

NewMembershipErrorModal.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.string,
  body: PropTypes.string,
};

export default NewMembershipErrorModal;
